import _MastersService from "../services/masters-service";
import { IMastersService } from "../types/services/masters-service";

const MastersService: IMastersService = new _MastersService();

export default MastersService;
